<template>
    <template-two-sidebars ref="template">
        <template #bradcrumbs> Vendas &#8226; Marketing &#8226; {{ layout.title }} </template>

        <!-- 
            CONTEÚDO DO HEADER
            - TITULO E SUBTITULO
         -->
        <template v-if="leadInfo.title || layout.title" #header-left>
            <div class="title">
                {{ layout.title }}
                <small v-if="layout.subTitle" class="page-name" > - {{ layout.subTitle }}</small>
            </div>
            <div class="subtitle">Faça a configuração da fila para a distribuição de leads.</div>
        </template>

        <!-- 
            CONTEÚDO DO HEADER
            - BOTOES DE AÇÃO
         -->
        <template v-if="leadInfo.type || (leadQueue && leadQueue.type)" #header-right >
            <div v-if="leadQueue && leadQueue.id" class="button-link" @click="showSchedule" >
                <i class="fal fa-clock"/> Definir horários de atendimento
            </div>

            <ui-button v-if="leadQueue && leadQueue.id" design="md2 primary" @click="showRightSidebar" >
                Selecionar Usuários <i class="fal fa-plus"/>
            </ui-button>

            <ui-menu-card icon="fal fa-cog" icon-size="22">
                <button type="button" @click="showLeftSidebar">Configurações da Fila</button>
                <button v-if="leadQueue && leadQueue.id" type="button" @click="showHistorySidebar">Histórico de Processamento</button>
                <button v-if="(leadQueue && leadQueue.type === 'form') || leadInfo.type === 'form' && ( leadQueue && leadQueue.id)" type="button" @click="showFormData">Dados do Formulário</button>
                <button v-if="leadQueue && leadQueue.id" type="button" @click="showRightSidebar('upload')">Importar Leads</button>
                <button v-if="leadQueue && leadQueue.id" type="button" @click="removeHandler">Excluir Fila</button>
            </ui-menu-card>
        </template>

        <!-- 
            CONTEÚDO DA PÁGINA
            - SIDEBAR DA ESQUERDA
            - FORMULÁRIO DE EDIÇÃO DA FILA
         -->
        <template #sidebar-left="{ show, hide, toggle }">
            <ui-sidebar-form-add-queue 
                :methods="{ show, hide, toggle }" 
                @submit="onFormAddQueueSubmit" 
                @completed="loadFilters"
            />
        </template>

        <!-- 
            CONTEÚDO DA PÁGINA
            - SIDEBAR DA DIREITA
            - SELEÇÃO DE USUÁRIOS
         -->
        <template #sidebar-right="{ show, hide, toggle }">
            <ui-sidebar-select-users
                :methods="{ show, hide, toggle }"
                :show-upload="layout.showUploadOnSidebar"
            />
        </template>

        <!-- 
            CONTEÚDO DA PÁGINA
            - CONTEÚDO PRINCIAL/CENTRAL DA TELA
            - TABELA DE USUÁRIOS
         -->
        <template #content>
            <!--
                verifica se tem usuários selecionados
                se não tiver mostra a tela com o botão para adicionar user
                se tiver mostra a tabela com os users
            -->
            <div v-if="!data.length" class="page-no-content">
                <div v-if="loader.tableQueueList" class="page-no-content-box">
                    <ui-load-indicator :h="50" :stroke="8" bg-color="#e7e9f4" color="#69D296" />
                </div>

                <div v-else class="page-no-content-box">
                    <ui-button
                        :disabled="layout.disableButtonAddUser"
                        design="lg primary btn-add-user"
                        @click="showRightSidebar">
                        <i class="fal fa-plus" />
                    </ui-button>
                    <div class="title">
                        Você ainda não <b>selecionou</b> nenhum <b>usuário</b>. <br />Clique para selecionar.
                    </div>
                </div>
            </div>

            <div v-else class="scroller scroll-color">
                <div class="page-content">
                    <div class="page-title">
                        <div class="title">Usuários selecionados</div>

                        <div class="search-box">
                            <ui-search-box v-model="form.data.search" event="marketing-queue-user-list-search" placeholder="Buscar usuário" />
                        </div>

                        <div v-if="selected.length" class="actions">
                            <ui-select
                                v-model="form.data.action"
                                class="md select-bulk-action"
                                label="Ação em massa:"
                                size="sm"
                                @input="bulkActionSelectHandler">
                                <option v-for="(option, index) in bulkActionOptions" :key="index" :value="option.value">
                                    {{ option.label }}
                                </option>
                            </ui-select>
                            <div class="quantidade">Existe <b class="color-primary">{{ selected.length }} usuários</b> selecionados</div>
                        </div>
                    </div>

                    <section class="table-items">

                        <ui-table
                            :data="dataComputed"
                            :per-page="25"
                            :columns="tableColumnsComputed"
                            :loading="loader.tableQueueList"
                            :all-selected="isSelectedAllComputed"
                            name="marketingQueueListConfiguration"
                            tr-component="marketing/queue-add/table-line"
                            not-found-icon="fal fa-user"
                            not-found-text="Nenhuma Fila foi encontrada."
                            selectable
                            :draggable="layout.isDraggable"
                            @drag="dragHandle"
                            @reload="loadData"
                            @selected="selectedHandler"
                            @select-all="selectAllHandler"
                        />
                    </section>
                </div>

                <ui-modal-message
                    v-if="selected.length > 1"
                    name="marketing-queues-add-remove-user"
                    :title="`Excluir ${selected.length} usuários da fila.`"
                    service="lead"
                    text="Tem certeza que deseja excluir os usuários da fila?"
                    btn-type="danger"
                    btn-text="Excluir"
                    icon-circle
                    color-circle="danger"
                    icon="fal fa-trash-alt" />

                <ui-modal-message
                    v-else
                    name="marketing-queues-add-remove-user"
                    title="Excluir usuário da fila."
                    text="Tem certeza que deseja excluir o usuário da fila?"
                    service="lead"
                    :image="defaultImage"
                    btn-type="danger"
                    btn-text="Excluir"/>
            </div>

            <!-- 
                COMPONENTES USADOS NA TELA
                - SIDEBAR DE HISTÓRICO
                - MODAL DE CONFIRMAR A EXCLUSÃO DA LISTA
                - MODAL DE CONFIRMAR A EXCLUSÃO DO(S) USUÁRIO(S)
            -->
            <ui-history-sidebar />

            <ui-modal-message
                name="marketing-queues-add-remove-queue"
                title="Excluir Fila."
                text="Tem certeza que deseja excluir esta fila?"
                service="lead"
                btn-type="danger"
                btn-text="Excluir"
                icon-circle
                color-circle="danger"
                icon="fal fa-trash-alt" />

            <ui-form-data-modal />
            <ui-call-tracking-modal />
            <ui-schedule-modal />
        </template>
    </template-two-sidebars>
</template>

<script>
    import templateTwoSidebars from '@/templates/page-two-sidebars'
    import { uiTable, uiMenuCard, uiLoadIndicator, uiSearchBox } from '@/components/ui'
    import { uiSelect } from '@/components/ui/form'
    import { uiButton } from '@/components/ui/buttons'
    import { uiModalMessage } from '@/components/ui/modal'

    import userImage from "@/assets/imgs/no-avatar.png"

    import uiHistorySidebar from '../components/sidebar-queues-history'
    import uiSidebarFormAddQueue from '../components/sidebar-form-add-queue'
    import uiSidebarSelectUsers from '../components/sidebar-select-users'
    import uiFormDataModal from '../components/form-data-modal'
    import uiCallTrackingModal from '../components/call-tracking-modal'
    import uiScheduleModal from '../components/schedule-modal'

    import { lead } from '@/services/axios'
    import { storage } from '@/services/storage'

    import helpers from '@/mixins/helpers'

    import { mapGetters } from 'vuex'

    const defaultLayout = () => {
        return {
            showUploadOnSidebar: false,
            disableButtonAddUser: true,
            showTopButtons: false,
        }
    }

    const defaultLoader = () => {
        return {
            tableQueueList: false,
        }
    }

    export default {
        name: 'ui-marketing-queues-add',

        components: {
            templateTwoSidebars,
            uiTable,
            uiMenuCard,
            uiLoadIndicator,
            uiSelect,
            uiButton,
            uiModalMessage,
            uiHistorySidebar,
            uiSidebarFormAddQueue,
            uiSidebarSelectUsers,
            uiFormDataModal,
            uiCallTrackingModal,
            uiScheduleModal,
            uiSearchBox,
        },

        mixins: [helpers],
        props: {
            /**
             * Identificador da fila de leads a ser mostrada
             */
            id: {
                type: [String, Number],
                required: false,
                default: 0
            },
        },

        data() {
            return {
                data: [],
                filteredData: [],
                layout: {
                    showUploadOnSidebar: false,
                    disableButtonAddUser: true,
                    title: '',
                    subTitle: '',
                    selectedAll: false,
                    leftSideBarOpen: false,
                    isDraggable: true
                },
                loader: {
                    tableQueueList: false,
                    showTopButtons: false,
                },
                form: {
                    data: {
                        action: null,
                        search: ''
                    }
                },
                bulkActionOptions: [
                    { value: 'delete', label: 'Remover Selecionados' }
                ]
            }
        },

        computed: {
            ...mapGetters('lead', {
                leadQueue: 'getQueue',
                selected: 'getSelected',
                leadInfo: 'getLeadInfo'
            }),
            defaultImage(){
                if (this.selected.length) {
                    return this.selected[0].user.photo || userImage
                }

                return userImage
            },
            tableColumnsComputed() {
                let columns = [
                    { title: 'Posição', },
                    { title: 'Usuários Selecionados', },
                    { title: 'Clientes Recebidos', },
                    {
                        title: '',
                        class: 'td-status',
                    },
                    { title: '', },
                ]
                
                if (this.leadQueue && this.leadQueue.type === 'chat') {
                    columns.splice(3, 0, { title: 'Clientes Online ?' })
                    columns.splice(4, 0, { title: 'Clientes Offline ?' })
                }

                return columns
            },
            dataComputed() {
                return Object.values(this.data).filter(e => {
                    let first_name = e.user.first_name.toLowerCase()
                    /** Salva para o usuário o tipo e ID da fila */
                    e.queue_id = this.leadQueue.id
                    e.queue_type = this.leadQueue.type
                    /** Verifica quais os status do usuário na fila */
                    encodeURIComponent.status_last_user = this.leadQueue.historyLastUser
                        ? this.leadQueue.historyLastUser.user_id === lead.user_id
                        : false
                    const leadNext = this.leadQueue.position + 1
                    encodeURIComponent.status_next_user = this.leadQueue.type !== 'chat'
                        ? (lead.order === 1 && leadNext > this.leadQueue.lusers.length) || (leadNext === lead.order)
                        : false

                    if (
                        (this.form.data.search.length > 3 && first_name.includes(this.form.data.search.toLowerCase())) || 
                        this.form.data.search.length <= 3
                    ) {
                        return e
                    }
                })
            },
            isSelectedAllComputed(){
                return this.dataComputed.length === this.selected.length
            },
        },

        watch: {
            'form.data.search': function(val) {
                if (val.length > 3) this.layout.isDraggable = false
                else this.layout.isDraggable = true
            },  
        },

        async mounted(){
            this.$store.dispatch('lead/clearSelected')

            if (!this.id) {
                this.$store.dispatch('lead/clearLeadInfo')
                this.$store.dispatch('lead/setQueue', null)

                this.$set(this.layout, 'title', 'Cadastrar Fila')
                this.$set(this.layout, 'subTitle', '')

                this.showLeftSidebar()
            }else { 
                const leadInfo = this.$store.state.lead.leadInfo
                if (leadInfo && leadInfo.title) {
                    this.$set(this.layout, 'title', 'Configurações da fila')
                    this.$set(this.layout, 'subTitle', leadInfo.title)
                }

                await this.loadData()
            }

            await this.callLoadSidebarConfig()

            this.$root.$on('modal-msg-open-marketing-queues-add-remove-user-response', async () => {
                await this.loadData()
            })

            this.$root.$on('modal-msg-open-marketing-queues-add-remove-queue-response', async () => {
                await this.loadData()

                this.$root.$emit('sidebar-select-users-reload-data')
            })

            this.$root.$on('modal-msg-open-marketing-queues-add-remove-user-close', () => {
                this.$set(this.form.data, 'action', null)
            })

            this.$root.$on('removed', () => {
                this.$router.push({ name: 'marketing.queues.list'})
            })

            this.$root.$on('select-user-input', (data) => {
                this.selectUsers(data)
            })
        },

        beforeDestroy() {
            this.$root.$off('modal-msg-open-marketing-queues-add-remove-user-close')
            this.$root.$off('modal-msg-open-marketing-queues-add-remove-user-response')
            this.$root.$off('modal-msg-open-marketing-queues-add-remove-queue-response')
            this.$root.$off('sidebar-form-add-queue-submit-success')
            this.$root.$off('removed')
            this.$root.$off('select-user-input')
        },

        methods: {
            loadData: async function() {
                this.$set(this.loader, 'tableQueueList', true)
                await lead.get('', this.id, {})
                    .then(response => {
                        this.$store.dispatch('lead/clearSelected')
                        this.$store.dispatch('lead/setQueue', { ...response.data })

                        this.$set(this.layout, 'title', 'Configurações da fila')
                        this.$set(this.layout, 'subTitle', response.data.name)
                        this.$set(this.form.data, 'action', null)

                        if (response.data && response.data.lusers) this.data = [...response.data.lusers]

                        if (this.data.length) this.$set(this.layout, 'showTopButtons', true)

                        this.$set(this.layout, 'disableButtonAddUser', false)
                    })
                    .catch(error => {
                        if (error.data && error.data.msg) this.$toastr.e(error.data.msg)
                        this.$router.push({ name: 'marketing.queues.list' })
                    })
                    .finally(() => {
                        this.$set(this.loader, 'tableQueueList', false)

                        this.$root.$emit('sidebar-select-users-reload-data')
                    })
            },
            /**
             * Carrega as configurações necessárias para ativar o CallTracking
             */
            loadConfigurations() {
                // Carrega a configuração à partir do localStorage
                const allowedMenu = storage.get('allowed_menu') || []

                // Verifica se o CallTracking está ativo
                if (allowedMenu.includes('calltracking')) {
                    this.$set(this.layout, 'canViewCallTrack', true)
                }
            },
            /**
             * Reseta o layout
             */
            resetLayout() {
                this.layout = { ...defaultLayout() }
            },
            /**
             * Reseta os loadings
             */
            resetLoader() {
                this.loader = { ...defaultLoader() }
            },
            /**
             * Abrir o modal de Agenda
             */
            showSchedule() {
                this.$root.$emit('modal-open-marketing-queues-add-schedule', { id: this.leadQueue.id, pageTitle: this.layout.subTitle })
            },
            /**
             * Evento disparado quando clica no botão 'Histórico de Processamento'
             * o botão está no <menu-card />
             * Abre o sidebar com o histórico
             */
            showHistorySidebar() {
                this.$root.$emit('sidebar-open-marketing-queues-history')
            },
            /**
             * Evento disparado quando clica no botão 'Excluir Lista'
             * O botão está no <menu-card />
             * Mostra o modal de confirmação de exclusão da Fila
             */
            removeHandler() {
                const data = {
                    method: 'delete',
                    id: '',
                    url: this.id,
                    formdata: {},
                    eventSuccess: 'removed'
                }
                this.$root.$emit('modal-msg-open-marketing-queues-add-remove-queue', data)
            },
            /**
             * Trata o evento de quando um usuário da fila é selecionado na tabela
             */
            selectedHandler(event) {
                this.$store.dispatch('lead/setSelected', event)
            },
            /**
             * Trata o evento de seleção de todos os itens da tabela
             */
            selectAllHandler() {
                this.$store.dispatch('lead/selectAllUsers') 
            },
            /**
             * Evento disparado quando clica no botão 'Remover'
             * o botão está no modal de confirmação de exclusão da Fila
             */
            removedHandler() {
                this.$router.push({ name: 'marketing.queues.list' })
            },
            /**
             * Evento disparado quando se altera a select 'Ação Em Massa'
             */
            bulkActionSelectHandler() {
                if (!this.selected.length) {
                    this.$set(this.form.data, 'action', null)
                    this.$toastr.w('Selecione usuários para executar uma ação')
                    return
                }

                // this.$set(this.loader, 'tableQueueList', true)
                switch (this.form.data.action) {
                    case 'delete': {
                        let usersIds = []
                        let usersPositions = []
                        
                        this.selected.find(e => {
                            usersIds.push(e.user_id)
                            usersPositions.push(e.order)
                        })

                        let data = {
                            method: 'delete',
                            id: '',
                            url: `${this.leadQueue.id}/users`,
                            formdata: {
                                data: {
                                    users: usersIds,
                                    positionUsers: usersPositions
                                }
                            },
                            eventSuccess: 'modal-msg-open-marketing-queues-add-remove-user-response',
                            eventClose: 'modal-msg-open-marketing-queues-add-remove-user-close'
                        }

                        if (this.selected.length == 1) {
                            data.image = this.getImgCDN(this.selected[0].user.photo)
                        }

                        this.$root.$emit('modal-msg-open-marketing-queues-add-remove-user', data)
                        break
                    }
                    default:
                        setTimeout(() => {
                            this.$set(this.loader, 'tableQueueList', false)
                        }, 1000)
                        break
                }
            },
            /**
             * Acessa o componente TEMPLATE via $refs e execulta o
             * médoto de mostrar o sidebar da esquerda
             * */
            showLeftSidebar() {
                this.$set(this.layout, 'leftSideBarOpen', true)
                this.$refs.template.toggleLeftSidebar()
            },
            /**
             * Acessa o componente TEMPLATE via $refs e execulta o
             * médoto de esconder o sidebar da esquerda
             * */
            hideLeftSidebar() {
                this.$set(this.layout, 'leftSideBarOpen', false)
                this.$refs.template.hideLeftSidebar()
            },
            /**
             * Acessa o componente TEMPLATE via $refs e execulta o
             * médoto de mostrar o sidebar da esquerda
             * @param String se for 'upload' o conteúdo do sidebar
             * será o de selecionar planinha, se não houver parametro
             * o sidebar abrirá com o formulário de selecionar usuários
             * */
            showRightSidebar(param) {
                if (param && param === 'upload') {
                    this.$set(this.layout, 'showUploadOnSidebar', true)
                } else {
                    this.$set(this.layout, 'showUploadOnSidebar', false)
                }

                this.$refs.template.showRightSidebar()
            },
            /**
             * Acessa o componente TEMPLATE via $refs e execulta o
             * médoto de esconder o sidebar da direita
             * */
            hideRightSidebar() {
                this.$refs.template.hideRightSidebar()
            },
            /**
             * Evento dispara ao submeter o formulario de cadastro/edição de fila
             * Formulário está no sidebar da esquerda
             */
            onFormAddQueueSubmit() {
                this.hideLeftSidebar()
                
                this.$nextTick(() => {
                    if (!this.id) {
                        this.$store.dispatch('lead/setLeadInfo', { title: this.leadQueue.name, type: this.leadQueue.type })
                        this.$router.push({ name: 'marketing.queues.config', params: { id: this.leadQueue.id }})
                    }
                    if(!this.leadQueue) {
                        this.showRightSidebar()
                    }
                })
            },
            /**
             * Mostra o modal com os dados do formulário
             */
            showFormData() {
                this.$root.$emit('modal-open-marketing-queues-form-data', this.leadQueue.id)
            },
            /**
             * Mostra o modal 'Call Tracking - Compra de números'
             */
            showCallTracking() {
                this.$root.$emit('modal-open-marketing-queues-call-tracking')
            },

            /**
             * Metodo disparado quando há se faz drag na tabela
             * @param {Array} é entregue o array da tabela atualizado com a nova ordem
             */
            dragHandle(event) {
                if (!event.item ||
                    !event.item.user_id ||
                    !(event.newIndex >= 0) ||
                    !this.leadQueue ||
                    !this.leadQueue.id) {
                    this.$toastr.e('Não foi possível alterar a ordem do item.')
                    return
                }

                const params = {
                    to_order: event.newIndex + 1,
                    user_id: event.item.user_id
                }

                lead.update(this.leadQueue.id, 'neworder', params)
                    .then(() => {
                        this.loadData()
                    })
                    .catch(error => {
                        if (error.data && error.data.msg) this.$toastr.e(error.data.msg)
                    })
            },

            selectUsers(data) {
                let params = { users: [...data] }

                lead.create(`${this.leadQueue.id}/users`, params)
                    .then(() => {
                        this.loadData()
                    })
                    .catch((error) => {
                        if (error.data && error.data.msg) this.$toastr.e(error.data.msg)
                    })
            },

            callLoadSidebarConfig() {
                this.$root.$emit('sidebar-form-add-queue-load-form')
            },

            loadFilters() {
                this.$root.$emit('sidebar-select-user-load-form')
            }
        }
    }
</script>

<style lang="stylus" scoped>
    @import 'styles.styl'
</style>
